import React, { useState } from 'react';
import { Layout, Button, Drawer, Menu, Typography } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

const { Header: AntHeader } = Layout;
const { Title } = Typography;

const useStyles = makeStyles(() => ({
  appBar: {
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    color: '#000',
    display: 'flex',
    alignItems: 'center',
    // padding: '0 10px',
    // margin: '0 10px',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    width: '100%',
    justifyContent: 'space-between',
  },
  logo: {
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'bold',
    fontSize: 24,
    flexGrow: 1,
    height: '120px',
    marginLeft: -15
  },
  button: {
    marginLeft: '10px',
    cursor: 'pointer',
    padding: '6px 12px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(10px)',
    border: 'none',
    color: '#000',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      color: '#555',
    },
  },
  menuButton: {
    fontSize: '20px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  },
}));

const Header = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });


  const handleNavigation = (path) => {
    if (path !== "/contact") {
      window.scrollTo({ top: 0, behavior: "smooth" }); // Scrolls to the top for all tabs except "Contact Us"
    }
    navigate(path); // Use your routing method (React Router, Next.js, etc.)
    setDrawerVisible(false); 
  };

  const handleScrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
    setDrawerVisible(false); // Close drawer after navigation (for mobile)
  };

  return (
    <AntHeader className={classes.appBar}>
      <div style={{ width: 113, height: 138, display: 'flex', alignItems: 'center' }}>
        <img src={require('../assets/logo.png')} alt="RaSynth Logo" className={classes.logo} />
      </div>
      
      {isMobile ? (
        <MenuOutlined className={classes.menuButton} onClick={() => setDrawerVisible(true)} />
      ) : (
        <div>
          {['/', '/services', '/about-us', '/blogs', '/contact'].map((path, index) => (
            <Button
              key={index}
              className={classes.button}
              onClick={() => path === '/contact' ? handleScrollToContact() : handleNavigation(path)}
            >
              {['Home', 'Services', 'About us', 'Blog', 'Contact us'][index]}
            </Button>
          ))}
        </div>
      )}
      <Drawer
        title="Menu"
        placement="right"
        closable
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
      >
        <Menu mode="vertical" onClick={({ key }) => key === '/contact' ? handleScrollToContact() : handleNavigation(key)}>
          {['/', '/services', '/about-us', '/blogs', '/contact'].map((path, index) => (
            <Menu.Item key={path}>{['Home', 'Services', 'About us', 'Blog', 'Contact us'][index]}</Menu.Item>
          ))}
        </Menu>
      </Drawer>
    </AntHeader>
  );
};

export default Header;
